import { Client } from "@/sharedTypes";
import { baseApi } from "../baseApi";

const clientTag = "Client";

export const clientApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getClients: builder.query<any, Record<string, any> | void>({
      query: (params) => {
        const queryString = params
          ? new URLSearchParams(params).toString()
          : "";
        return `/clients${queryString ? `?${queryString}` : ""}`;
      },
      providesTags: [clientTag],
    }),
    getClientById: builder.query<Client, string>({
      query: (id) => `/clients/${id}`,
      transformResponse: (response: any) => response?.data ?? response,
      providesTags: (_result, _error, id) => [{ type: clientTag, id }],
    }),
    createClient: builder.mutation<Client, Partial<Client>>({
      query: (clientData) => ({
        url: `/clients`,
        method: "POST",
        body: clientData,
      }),
      invalidatesTags: [clientTag],
    }),
    editClient: builder.mutation<Client, Client>({
      query: (clientData) => ({
        url: `/clients/${clientData.client_id}`,
        method: "PUT",
        body: clientData,
      }),
      invalidatesTags: [clientTag],
    }),
    deleteClient: builder.mutation<void, number>({
      query: (id) => ({
        url: `/clients/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [clientTag],
    }),
    restoreClient: builder.mutation<void, number>({
      query: (id) => ({
        url: `/clients/${id}/restore`,
        method: "PUT",
      }),
      invalidatesTags: [clientTag],
    }),
    hardDeleteClient: builder.mutation<void, number>({
      query: (id) => ({
        url: `/clients/${id}/permanent`,
        method: "DELETE",
      }),
      invalidatesTags: [clientTag],
    }),
    updateClientPassword: builder.mutation<void, { clientId: number; password: string }>({
      query: ({ clientId, password }) => ({
        url: `/clients/${clientId}/password`,
        method: "PUT",
        body: { client_password: password },
      }),
    }),
  }),
});

export const {
  useGetClientsQuery,
  useGetClientByIdQuery,
  useLazyGetClientsQuery,
  useCreateClientMutation,
  useEditClientMutation,
  useDeleteClientMutation,
  useRestoreClientMutation,
  useHardDeleteClientMutation,
  useUpdateClientPasswordMutation,
} = clientApi;
